import React from "react";
import { useFormContext } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { Form, FormActions, Grid, GridColumn, GridRow } from "sprint-common-web";

import { ciFileRecordsRoute, getCiFileRecordQcReviewPageHref } from "../../../../ContentIngestionRoutes";
import { CreateFileRecordNotesSection } from "../common/CreateFileRecordNotesSection";
import { CreateFileRecordFormInputs } from "../CreateFileRecordFormInputs";
import { useCreateFileRecordState } from "../hooks/state/useCreateFileRecordState";
import { useCreateFileRecord } from "../hooks/useCreateFileRecord";
import { CreateSubtitleFileRecordLanguagesForm } from "./CreateSubtitleFileRecordLanguagesForm";

export const CreateSubtitleFileRecordForm: React.FC = () => {
    const history = useHistory();
    const { isUpdatePending, createSubtitle, createFileRecordNotes, saveToHistory } = useCreateFileRecord();
    const { isLoading: isFormLoading } = useCreateFileRecordState();

    const { formState, handleSubmit, watch } = useFormContext<CreateFileRecordFormInputs>();

    const goToFileRecordsListing = () => history.push(ciFileRecordsRoute.path);
    const goToFileRecordDashboard = (fileRecordId: string) =>
        history.push(getCiFileRecordQcReviewPageHref(fileRecordId));

    const submit = async () => {
        const formData = watch();

        const { entityId: fileRecordId } = await createSubtitle(formData);

        await saveToHistory(formData);

        await createFileRecordNotes(fileRecordId, formData.notes);

        goToFileRecordDashboard(fileRecordId);
    };

    return (
        <Form onSubmit={handleSubmit(submit)}>
            <Grid>
                <GridRow>
                    <GridColumn>
                        <CreateSubtitleFileRecordLanguagesForm />
                        <CreateFileRecordNotesSection />
                    </GridColumn>
                </GridRow>
            </Grid>
            <FormActions
                onCancel={goToFileRecordsListing}
                submitDisabled={formState.isValidating || isFormLoading}
                isLoading={formState.isSubmitting || isUpdatePending}
            />
        </Form>
    );
};
